"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ProductDetailSpagettyItem = _interopRequireDefault(require("@sprinx/react-com/ProductDetailSpagettyItem"));

var _ProductDetailParameterList = _interopRequireDefault(require("./ProductDetailParameterList"));

var _ProductDetailSectionTitle = _interopRequireDefault(require("./ProductDetailSectionTitle"));

var _ProductDetailSectionTitleMobile = _interopRequireDefault(require("./ProductDetailSectionTitleMobile"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {},
      title: {},
      titleSection: {}
    }
  );
}, {
  name: 'ProductDetailSpagettyItemParameters'
});

var ProductDetailSpagettyItemParameters = /*#__PURE__*/_react.default.forwardRef(function ProductDetailSpagettyItemParameters(_ref, ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      collapsable = _ref.collapsable,
      product = _ref.product,
      renderToAnchor = _ref.renderToAnchor,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "collapsable", "product", "renderToAnchor"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _ref3 = /*#__PURE__*/_react.default.createElement(_ProductDetailParameterList.default, {
    product: product
  });

  return /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyItem.default, (0, _extends2.default)({}, rest, {
    activeZoneOffset: 70,
    collapsed: !collapsable,
    collapsable: collapsable,
    className: (0, _clsx.default)(classes.root, className),
    renderToAnchor: renderToAnchor,
    ref: ref
  }), function (_ref2) {
    var collapsed = _ref2.collapsed,
        handleToggleCollapse = _ref2.onToggleCollapse;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ProductDetailSectionTitle.default, {
      product: product,
      collapsed: collapsed,
      onToggleCollapse: handleToggleCollapse
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.title
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.titleSection
    }, t('productDetailSpagettyNavigation/parameters')), !collapsable && t(product.name))), collapsed && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ProductDetailSectionTitleMobile.default, {
      product: product,
      collapsable: collapsable,
      title: t('productDetailSpagettyNavigation/parameters')
    }), _ref3));
  });
});

process.env.NODE_ENV !== "production" ? ProductDetailSpagettyItemParameters.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    title: _propTypes.default.string,
    titleSection: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  collapsable: _propTypes.default.bool,
  product: _propTypes.default.shape({
    name: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired,
  renderToAnchor: _propTypes.default.string
} : void 0;
ProductDetailSpagettyItemParameters.defaultProps = {
  classes: undefined,
  className: undefined,
  collapsable: false,
  renderToAnchor: 'parameters'
};
var _default = ProductDetailSpagettyItemParameters;
exports.default = _default;